import React, { Fragment, useEffect, useState } from 'react';
import CustomizerComponent from '@bit/gerenciatd.unifiedcomponents.customizer-component';
import Banner from '@bit/gerenciatd.unifiedcomponents.banner';
import BarraDestacada, { COMPONENT_NAME as barraDestacadaName } from '../BarraDestacada';
import mainSetup from '../../../config/mainSetup';
import FlotanteWrapper from '../FlotanteWrapper';

const BannerFusion = (props) => {
  const {
    ModalComponent, SvgIconLoader, modalAtencionConfig, components,
  } = props;
  let productFinal = 'Home';
  if (components && components.contactBar) {
    components.contactBar.tabsOptions = modalAtencionConfig;
    const productLlamada = components.contactBar.components['Button-llamada'] && components.contactBar.components['Button-llamada'].product ? components.contactBar.components['Button-llamada'].product : '';
    const productSolicita = components.contactBar.components['Button-solicita'] && components.contactBar.components['Button-solicita'].product ? components.contactBar.components['Button-solicita'].product : '';
    productFinal = (productLlamada || (productSolicita || 'Home'));
  }

  return (
    <Fragment>
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-BARRA-DESTACADA-HOME"
        component={BarraDestacada}
        componentName={barraDestacadaName}
        customProps={{
          SvgIconLoader, Modal: ModalComponent, modalAtencionConfig,
        }}
      />
      <Banner {...props} />
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-BUTTON-CIRCLE-CONTACT"
        component={FlotanteWrapper}
        customProps={{
          SvgIconLoader, Modal: ModalComponent, modalAtencionConfig, product: productFinal,
        }}
        componentName="ContactCircle"
      />
    </Fragment>
  );
};

export default BannerFusion;
